import React, { useEffect, useMemo, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { viewInvitesList } from "../../Redux/Actions/invitesAction";
import { columnsInvites } from "../../Global Functions/columnsAntd";

const ListInvites = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, pageSize) => {
    const invitesData = {
      page,
      limit: pageSize,
    };
    dispatch(viewInvitesList(invitesData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const { invites } = useSelector((state) => state.invites || {});

  useEffect(() => {
    if (invites?.total) {
      setPagination((prevData) => ({ ...prevData, total: invites.total }));
    }
  }, [invites]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const columns = useMemo(() => columnsInvites, []);

  const dataSource = useMemo(
    () => (Array.isArray(invites?.data) ? invites.data : []),
    [invites]
  );
  
  return (
    <TableComponent
      h3heading="Invites List"
      pagination={pagination}
      columns={columns}
      dataSource={dataSource}
      onChange={handleTableChange}
    ></TableComponent>
  );
};

export default ListInvites;
